export default [
  {
    path: "",
    component: () => import("layouts/App"),
    children: [
      {
        path: "",
        component: () => import("layouts/auth/Index"),
        children: [
          {
            path: "",
            name: "login",
            icon: "genderless",
            component: () => import("pages/login/Index"),
            meta: { roles: [] },
          },
        ],
      },
      {
        path: "",
        component: () => import("layouts/main/Index"),
        children: [
          {
            path: "/companies",
            name: "companies",
            title: "Компании",
            icon: "genderless",
            component: () => import("pages/companies/Index"),
            meta: { roles: [
              'ROLE_MANAGER',
              'ROLE_ADMIN_PANEL_VIEWER',
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
            ] },
          },
          {
            path: "/settings-payout-provider",
            name: "settings.payout.provider",
            title: "Смена платежной системы",
            icon: "genderless",
            component: () => import("pages/settings-payout-provider/SettingsPayoutProvider"),
            meta: { roles: [
              'ROLE_MANAGER',
              'ROLE_ADMIN_PANEL_VIEWER',
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
            ] },
          },
          {
            path: "/settings-notification-type",
            name: "settings.notification.type",
            title: "Смена типа уведомлений",
            icon: "genderless",
            component: () => import("pages/settings-notification-type/SettingsNotificationType.vue"),
            meta: { roles: [
              'ROLE_MANAGER',
              'ROLE_ADMIN_PANEL_VIEWER',
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
            ] },
          },
          {
            path: "/reports",
            name: "reports",
            title: "Отчеты",
            icon: "genderless",
            component: () => import("pages/reports/Index.vue"),
          },
          {
            path: "/reports/ip-snr",
            name: "reports.ip.snr",
            title: "ИП СНР отчеты",
            icon: "genderless",
            component: () => import("pages/reports/ip-snr.vue"),
          },
          {
            path: "/reports/ip-snr/:id",
            name: "reports.ip.snr.detail",
            title: "Детали ИП СНР",
            icon: "genderless",
            component: () => import("pages/reports/ip-snr-detail.vue"),
          },
          {
            path: "/reports/ip-snr/:id/fiscalization",
            name: "reports.ip.snr.detail-fiscalization",
            icon: "genderless",
            component: () => import("pages/reports/ip-snr-fiscalization.vue"),
          },
          {
            path: "/history-action",
            name: "history.action",
            title: "История действий",
            icon: "genderless",
            component: () => import("pages/history-action/HistoryActionPage"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN'
            ] },
          },
          {
            path: "/document-templates",
            icon: "genderless",
            component: () => import("pages/document-templates"),
            children: [
              {
                path: "",
                name: "desktop.document.templates",
                component: () =>
                  import(
                    "pages/document-templates/templates/index.vue"
                  ),
              },
              {
                path: "documents",
                name: "desktop.document.templates.documents",
                component: () =>
                  import(
                    "pages/document-templates/documents/index.vue"
                  ),
              },
              {
                path: "queries",
                name: "desktop.document.templates.queries",
                component: () =>
                  import("pages/document-templates/queries/index.vue"),
              },
            ],
          },
          {
            path: "/desktop/document-templates/:id/edit",
            name: "desktop.document.templates.edit",
            component: () =>
              import(
                "pages/document-templates/templates/EditTemplate.vue"
              ),
          },
          {
            path: "/generate-template",
            name: "desktop.generate.template",
            icon: "genderless",
            component: () => import("pages/generate-template"),
          },
          {
            path: "/statistics",
            name: "statistics",
            icon: "genderless",
            component: () => import("pages/statistics/Index.vue"),
          },
          {
            path: "/support",
            name: "support",
            title: "Поддержка",
            icon: "genderless",
            component: () => import("pages/support/support"),
            meta: { roles: [
              'ROLE_ADMIN_PANEL_VIEWER',
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_MANAGER'
            ] },
          },
          {
            path: "/access-control",
            name: "access.access",
            title: "Управление доступами",
            icon: "genderless",
            component: () => import("pages/access-control-page/AccessControlPage"),
            meta: { roles: [
              'ROLE_SUPER_ADMIN'
            ] },
          },
          {
            path: "/excel",
            name: "excel",
            title: "Выгрузка",
            icon: "genderless",
            component: () => import("pages/excel/Index"),
            meta: { roles: [
              'ROLE_SUPER_ADMIN',
              'ROLE_APP_ADMIN',
              'ROLE_MANAGER',
              'ROLE_ADMIN_PANEL_VIEWER'
            ] },
          },
          {
            path: "/integration",
            name: "integration",
            title: "Интеграция",
            icon: "genderless",
            component: () => import("pages/integration/Index"),
            meta: { roles: [
              'ROLE_MANAGER',
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
            ] },
          },
          {
            path: "/transaction-modifier",
            name: "transaction-modifier",
            title: "Редактирование транзакций",
            icon: "genderless",
            component: () => import("pages/transaction-modifier/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN'
            ] },
          },
          {
            path: "/payout-providers",
            name: "payout-providers",
            title: "Провайдеры выплат",
            icon: "genderless",
            component: () => import("pages/payout-providers/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN'
            ] },
          },
          {
            path: "/transaction-modifier-legacy",
            name: "transaction-modifier-legacy",
            title: "Управление транзакциями (legacy)",
            icon: "genderless",
            component: () => import("pages/transaction-modifier-legacy/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN'
            ] },
          },
          {
            path: "/companies/:companyId/departments/:id",
            name: "department",
            title: "Департамент",
            icon: "genderless",
            component: () => import("pages/department/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_MANAGER',
              'ROLE_ADMIN_PANEL_VIEWER'
            ] },
          },
          {
            path: "/companies/:companyId/filials/:id",
            name: "filials",
            title: "Филиалы",
            icon: "genderless",
            component: () => import("pages/filial/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_MANAGER',
              'ROLE_ADMIN_PANEL_VIEWER'
            ] },
          },
          {
            path: "/settings",
            name: "settings",
            title: "Переменные",
            icon: "genderless",
            component: () => import("pages/settings/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN'
            ] },
          },
          {
            path: "/prosper-start",
            name: "prosper-start",
            title: "Prosper Start",
            icon: "genderless",
            component: () => import("pages/prosper-start/Index"),
          },
          {
            path: "/ip-snr/subscription-management",
            name: "ip-snr-subscription-management",
            title: 'Управление подпиской',
            icon: "genderless",
            component: () => import("pages/ip-snr/subscription/Index.vue"),
          },
          {
            path: "/fiscalizations",
            name: "fiscalizations",
            title: 'Список фискализаций',
            component: () => import("pages/fiscalizations/Index.vue"),
            beforeEnter: (to, from, next) => {
              if ('page' in to.query) next()
              else {
                return next({
                  ...to,
                  query: {
                    page: 0
                  }
                })
              }
            },
          },
          {
            path: "/reconciliation",
            name: "reconciliation",
            title: "Сверка с реестром КГД",
            component: () => import("pages/reconciliation/Index.vue"),
          },
          {
            path:"/reconciliation/new",
            name: "reconciliation.new",
            title: "Новая сверка",
            component: () => import("pages/reconciliation/new/Index.vue"),
          },
          {
            path: 'kgd-registry',
            name: 'kgd-registry',
            title: 'Реестр налоговых отчислений КГД',
            component: () => import("pages/kgd-registry/Index.vue"),
          },
          {
            path: "/company/:id",
            name: "company",
            title: "Компания",
            icon: "genderless",
            component: () => import("pages/company/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_MANAGER',
              'ROLE_ADMIN_PANEL_VIEWER'
            ] },
          },
          {
            path: "/stats",
            name: "stats",
            title: "Статистика приложения",
            icon: "genderless",
            component: () => import("pages/app-stats/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_MANAGER'
            ] },
          },
          {
            path: "/applications",
            name: "applications",
            title: "Заявки тех поддержки",
            icon: "genderless",
            component: () => import("pages/applications/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_MANAGER',
              'ROLE_ADMIN_PANEL_VIEWER'
            ] },
          },
          {
            path: "/faqs",
            name: "faqs",
            title: "FAQ",
            icon: "genderless",
            component: () => import("pages/faqs/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_MANAGER',
              'ROLE_ADMIN_PANEL_VIEWER'
            ] },
          },
          {
            path: "/users",
            name: "users",
            title: "Пользователи",
            icon: "genderless",
            component: () => import("pages/users/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_ADMIN_PANEL_VIEWER',
              'ROLE_MANAGER'
            ] },
          },
          {
            path: "/users/:id",
            name: "user",
            title: "Пользователь",
            icon: "genderless",
            component: () => import("pages/user/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_ADMIN_PANEL_VIEWER',
              'ROLE_MANAGER'
            ] },
          },
          {
            path: "/password",
            name: "password",
            title: "Смена пароля",
            icon: "genderless",
            component: () => import("pages/password/Index"),
            meta: { roles: [ 'ROLE_SUPER_ADMIN' ] },
          },
          {
            path: "/promotions",
            name: "promotions",
            title: "Акции",
            icon: "genderless",
            component: () => import("pages/promotions/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_MANAGER',
              'ROLE_APP_ADMIN'
            ] },
          },
          {
            path: "/promotions/:id",
            name: "promotion",
            title: "Акция",
            icon: "genderless",
            component: () => import("pages/promotion/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_MANAGER'
            ] },
          },
          {
            path: "/notifications",
            name: "notifications",
            title: "Уведомления",
            icon: "genderless",
            component: () => import("pages/notifications/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_MANAGER'
            ] },
          },
          {
            path: "/mailing",
            name: "mailing",
            title: "Рассылка",
            icon: "genderless",
            component: () => import("pages/mailing/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_MANAGER'
            ] },
          },
          {
            path: "/notifications/create",
            name: "notificationsCreate",
            title: "Создание уведомления",
            icon: "genderless",
            component: () => import("pages/notifications-create/Index"),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_MANAGER'
            ] },
          },
          { path: '/access-blocks', 
            name: 'access-blocks', 
            title: 'Блокировка', 
            icon: 'genderless', component: () => import('pages/access-blocks/Index'),
            meta: { roles: [
              'ROLE_SUPER_ADMIN',
              'ROLE_APP_ADMIN'
            ] },
          },
          { path: '/access-blocks/create', 
            name: 'accessBlocksCreate', 
            title: 'Создание блокировки', 
            icon: 'genderless', component: () => import('pages/access-blocks-create/Index'),
            meta: { roles: [
              'ROLE_SUPER_ADMIN',
              'ROLE_APP_ADMIN'
            ] },
          },
          { path: '/antifraud',
            name: 'antifraud',
            title: 'Доп проверка',
            icon: 'genderless', component: () => import('pages/antifraud/Index'),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN'
            ] },
          },
          {
            path: '/antifraud-legacy',
            name: 'antifraud-legacy',
            title: 'Доп проверка (legacy)',
            icon: 'genderless',
            component: () => import('pages/antifraud-legacy/Index'),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN'
            ] },
          },
          { path: '/holidays',
            name: 'holidays',
            title: 'Праздничные дни',
            icon: 'genderless', component: () => import('pages/holiday-page/HolidayPage'),
            meta: { roles: [
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN'
            ] },
          },
          { path: '/history-entry',
            name: 'history.entry',
            title: 'История входа',
            icon: 'genderless', component: () => import('pages/history-entry/HistoryEntry.vue'),
            meta: { roles: [
              'ROLE_SUPER_ADMIN',
              'ROLE_APP_ADMIN',
              'ROLE_SUPER_ADMIN',
              'ROLE_ADMIN_PANEL_VIEWER',
              'ROLE_MANAGER'
            ] },
          },
          {
            path: '/reconciliation-of-withheld-taxes',
            name: 'reconciliation-of-withheld-taxes',
            component: () => import('pages/reconciliation-of-withheld-taxes/index.vue')
          }
        ],
      },
    ],
  },
]
